/**
 * Course "preview as student" — token lives in memory + sessionStorage only (never localStorage).
 * URL `?preview=` is stripped after capture so links are not accidentally shared with the token.
 */

const STORAGE_KEY = "progsity:coursePreviewToken";

export function readStoredCoursePreviewToken(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function persistCoursePreviewToken(token: string): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearStoredCoursePreviewToken(): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Resolve JWT for API calls: current URL wins, then module store, then sessionStorage. */
export function resolveCoursePreviewTokenForRequest(): string | null {
  if (typeof window !== "undefined") {
    const fromUrl = new URLSearchParams(window.location.search).get("preview");
    if (fromUrl?.trim()) return fromUrl.trim();
  }
  return null;
}
